import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import AuthRoutes from "@/views/auth/routes";
import WizardRoutes from "@/views/wizard/routes";
import BaseRoutes from "@/views/base/routes";
import { UserClaims } from '@/types/user.type';
import { Roles } from '@/types/enums.type';

Vue.use(VueRouter);

const getHomeRedirectPath = (): string | undefined => {
  const userInfoRaw = sessionStorage.getItem("user-info");

  if (!userInfoRaw){
    return;
  }
    
  const userInfo = JSON.parse(userInfoRaw) as UserClaims;

  if (userInfo.role === Roles.CustomerSupport) {
    return "/customer-support/dashboard"
  }

  return "/shifts";
}

const homeRoute = {
  path: "/",
  redirect: getHomeRedirectPath()
}

const routes: Array<RouteConfig> = [
  ...AuthRoutes,
  ...WizardRoutes,
  ...BaseRoutes,
  homeRoute
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to: Route, _, next) => {
  if (!to.meta?.roles && to.path !== "/") {
    next();

    return;
  }

  const userInfo = sessionStorage.getItem('user-info');

  if (!userInfo) {
    return next({ name: 'Login', replace: true });
  }

  const tokenData: UserClaims = JSON.parse(userInfo);

  if (to.meta?.roles?.every((role: string) => role !== tokenData.role)) {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user-info');
    sessionStorage.removeItem('support-user-info');
    sessionStorage.removeItem('support-token');
    next({ name: 'Login', replace: true });
  }

  if (to.name === 'Wizard') {
    const userInfo = sessionStorage.getItem('user-info');

    if (!userInfo) {
      return next({ name: 'Login', replace: true });
    }

    const userInfoData = JSON.parse(userInfo) as UserClaims;

    if (userInfoData.isWizardComplete) {
      next({ name: 'Shifts', replace: true });
    }
  }

  next();
});

export default router;